module.exports = __webpack_public_path__ + "img/AT0000002575759.e80da6e2.png";